export const translations = {
  en: {
    guarantorVerification: {
      editGuarantorModalAlert:
        'Updates made to your guarantor will require a review at your appointment. Bring their updated information with you so we can verify it with you.',
      editGuarantorModalInvalidFieldError: '{{fieldName}} is invalid.',
      editGuarantorModalRequiredFieldError: '{{fieldName}} is required.',
      editGuarantorModalTitle: 'Edit guarantor',
      editGuarantorWarningBadge: 'Update pending review',
      someoneElseAlert:
        'Bring this person’s contact details to the appointment so we can add them as a guarantor.',
      someoneElsePlaceholder: 'Who is this person?',
    },
  },
  es: {
    guarantorVerification: {
      editGuarantorModalAlert:
        'Las actualizaciones realizadas en tu garante requerirán una revisión en tu cita. Trae su información actualizada contigo para que podamos verificarla contigo.',
      editGuarantorModalInvalidFieldError: '{{fieldName}} no es válido.',
      editGuarantorModalRequiredFieldError: '{{fieldName}} es obligatorio.',
      editGuarantorModalTitle: 'Editar garante',
      editGuarantorWarningBadge: 'Actualización pendiente de revisión',
      someoneElseAlert:
        'Lleva los detalles de contacto de esta persona a la cita para que podamos agregarla como garante.',
      someoneElsePlaceholder: '¿Quién es esta persona?',
    },
  },
};
